<section [ngClass]="dynamicClass">
  <app-hero-internal *ngIf="CardData?.Image?.value?.src" [data]="CardData"></app-hero-internal>
  <app-breadcrumb *ngIf="breadcrumbData" [data]="breadcrumbData"></app-breadcrumb>
  <!-- Highlights START-->
  <section *ngIf="highlight == true " class="pb-container pb-highlights">
    <div class="pb-flex pb-flex-col lg:pb-flex-row lg:pb-pb-0 pb-pl-0 lg:pb-pl-7 pb-h-full"
      style="background-color: rgba(var(--pb-m-hightlight-background),1); min-height: 100px;">
      <ng-container>
        <div 
          class="pb-flex pb-flex-col lg:pb-flex-row pb-gap-0 pb-justify-evenly lg:pb-gap-7 xl:pb-gap-11 pb-items-start pb-w-full">
          <!-- Duration -->
          <div *ngIf="CardData.DurationValue?.value"
            class="pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-text-left pb-border-b last:pb-border-b-0 pb-items-center pb-w-full pb-gap-4 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
            <h2 class="pb-text-xs lg:pb-mb-1 pb-mb-0 pb-w-1/2 lg:pb-w-auto" *scText="CardData.DurationLabel"></h2>
            <div class="pb-w-1/2 lg:pb-w-auto">
              <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold" *scText="CardData.DurationValue"></h3>
              <p class="pb-text-xs pb-font-bold" *scText="CardData.DurationNote"></p>
            </div>
          </div>
          <!-- MinimumAmount -->
          <div *ngIf="CardData.MinimumAmountValue?.value"
            class="pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-text-left pb-border-b last:pb-border-b-0 pb-items-center pb-w-full pb-gap-4 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
            <h2 class=" pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0" *scText="CardData.MinimumAmountLabel">
            </h2>
            <div class="pb-w-1/2 lg:pb-w-auto">
              <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
                {{CardData.MinimumAmountValue?.value}}
              </h3>
              <p class="pb-text-xs pb-font-bold" *scText="CardData.MinimumAmountNote"></p>
            </div>
          </div>
          <!-- Rate -->
          <div *ngIf="CardData.RateValue?.value"
            class="pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-text-left pb-border-b last:pb-border-b-0 pb-items-center pb-w-full pb-gap-4 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
            <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0" *scText="CardData.RateLabel">
            </h2>
            <div class="pb-w-1/2 lg:pb-w-auto">
              <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
                {{CardData.RateValue?.value}}
              </h3>
              <p class="pb-text-xs pb-font-bold" *scText="CardData.RateNote"></p>
            </div>
          </div>
          <!-- InterestReturn -->
          <div *ngIf="CardData.InterestReturnValue?.value"
            class="pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-border-b last:pb-border-b-0 pb-text-left pb-items-center pb-w-full pb-gap-4 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
            <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0" *scText="CardData.InterestReturnLabel"></h2>
            <div class="pb-w-1/2 lg:pb-w-auto">
              <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
                {{CardData.InterestReturnValue?.value}}
              </h3>
              <p class="pb-text-xs pb-font-bold" *scText="CardData.InterestReturnNote"></p>
            </div>
          </div>
           <!-- Type -->
           <div *ngIf="CardData.TypeValue?.value"
           class="pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-border-b last:pb-border-b-0 pb-text-left pb-items-center pb-w-full pb-gap-4 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
           <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0" *scText="CardData.TypeLabel"></h2>
           <div class="pb-w-1/2 lg:pb-w-auto">
             <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
               {{CardData.TypeValue?.value}}
             </h3>
             <p class="pb-text-xs pb-font-bold" *scText="CardData.TypeNote"></p>
           </div>
         </div>
        </div>
      </ng-container>

      <div class="pb-block lg:pb-hidden pb-border-b pb-c-highlight-item"></div>
      <div *ngIf="CardData?.HighlightButton?.value?.href"
        class="lg:pb-w-auto pb-w-11/12 pb-pt-6 lg:pb-pt-0 pb-pb-6 lg:pb-pb-0 lg:pb-block pb-self-center lg:pb-self-auto pb-items-center ">
        <a *ngIf="CardData?.OnlineIssueing" hreflang="{{language}}" href="{{CardData?.HighlightButton?.value?.href}}" aria-label="#"
          class="pb-h-full pb-px-5 pb-py-4 pb-space-y-1 pb-bg-link  pb-self-center pb-items-center pb-flex pb-justify-between lg:pb-items-start lg:pb-flex-col">
          <h2 class="pb-hidden lg:pb-block pb-text-xs">{{CardData?.HighlightButton?.value?.title}}</h2>
          <h3 class="pb-text-h-sm pb-font-bold">{{CardData?.HighlightButton?.value?.text}}</h3>
          <i class="pb-icon pb-icon-arrow-right lg:pb-text-i-32 pb-text-i-24"></i>
        </a>
      </div>
    </div>

  </section>
  <!-- Highlights END -->
  <!-- Banner-Image-List START -->
  <section *ngIf="CardData?.FaceCardImage?.value?.src || (energySave && CardData?.FaceCardImage?.value?.src)" class="pb-container">
    <div class="pb-flex pb-flex-col pb-gap-5 lg:pb-gap-6 lg:pb-flex-row-reverse">
      <div class="lg:pb-w-1/2">
        <img offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="CardData?.FaceCardImage?.value?.src" *ngIf="!isMobile && !energySave"
          alt="{{CardData?.FaceCardImage?.value?.alt}}" class="pb-aspect-[4/3] pb-object-cover" />
        <img offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="CardData?.FaceCardImage?.value?.src" *ngIf="isMobile && !energySave" 
          alt="{{CardData?.FaceCardImage?.value?.alt}}" class="pb-h-full pb-object-cover" />
        <img offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="CardData?.FaceCardImageGreen?.value?.src" *ngIf="!isMobile && energySave" 
          alt="{{CardData?.FaceCardImageGreen?.value?.alt}}" class="pb-aspect-[4/3] pb-object-cover pb-energy-image" />
        <img offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="CardData?.FaceCardImageGreen?.value?.src" *ngIf="isMobile && energySave" 
          alt="{{CardData?.FaceCardImageGreen?.value?.alt}}" class="pb-h-full pb-object-cover pb-energy-image" />
      </div>
      <div class="pb-flex pb-flex-col lg:pb-gap-8 pb-w-full lg:pb-w-1/2">
        <h2 *ngIf="CardData?.DescriptionTitle?.value" class="pb-text-d-md-m lg:pb-text-d-md pb-font-serif">
          {{CardData?.DescriptionTitle?.value}}
        </h2>
        <div class="pb-text-md-m lg:pb-text-lg" [innerHTML]="CardData?.ShortDescription?.value"></div>
        <div class="pb-flex pb-flex-col pb-gap-5 pb-icon-list pb-mt-7 lg:pb-mt-0"
          [innerHTML]="CardData?.KeyFeatures?.value"></div>
      </div>
    </div>
  </section>
  <section *ngIf="!CardData?.FaceCardImage?.value?.src || !(energySave && CardData?.FaceCardImage?.value?.src)" class="pb-container">
    <div class="pb-flex pb-flex-col lg:pb-flex-row pb-gap-6">
      <div class="lg:pb-w-7/12">
        <div class="pb-text-md-m lg:pb-text-lg lg:pb-w-5/6" [innerHTML]="CardData?.ShortDescription?.value"></div>
        <div *ngIf="CardData?.Link?.value?.href || CardData?.SecondaryLink?.value?.href" class="pb-flex pb-flex-col">
          <a *ngIf="CardData?.Link?.value?.href" hybridHref hreflang="{{language}}"  href="{{CardData?.Link?.value?.href}}"
            target="{{CardData?.Link?.value?.target}}" class="pb-mt-4 md:pb-w-fit">{{CardData?.Link?.value?.text}}</a>
          <a *ngIf="CardData?.SecondaryLink?.value?.href" hybridHref hreflang="{{language}}"  href="{{CardData?.SecondaryLink?.value?.href}}"
            target="{{CardData?.SecondaryLink?.value?.target}}"
            class="pb-mt-4 md:pb-w-fit">{{CardData?.SecondaryLink?.value?.text}}</a>
        </div>
      </div>
      <div class="pb-flex pb-flex-col pb-gap-4 lg:pb-gap-5 pb-w-full lg:pb-w-5/12 pb-icon-list"
        *scRichText="CardData?.KeyFeatures"></div>
    </div>
    <!-- TextBlock-END -->
  </section>
  <div class="pb-container pb-mt-8">
    <a *ngIf="CardData?.AnchorId?.value" pageScroll [pageScrollOffset]="120" [pageScrollDuration]="1000"
      href="#{{CardData?.AnchorId?.value}}" attr.aria-label="{{CardData?.AnchorId?.value}}"
      class="items-center pb-flex pb-w-fit pb-mt-5 lg:pb-mt-0 pb-cursor-pointer">
      <span
        class="pb-link pb-w-fit pb-font-bold">{{CardData?.AnchorTo?.value}}</span>
    </a>
    <a *ngIf="rendering.fields?.ModalText?.value && hasModal" href="#ContactForm" aria-label="Open contact form"
      (click)="openModal($event)"
      class="pb-link pb-w-fit pb-font-bold">{{rendering.fields?.ModalText?.value}}</a>
  </div>
</section>